<template>
  <div class="container-fluid">
    <Topbar />
    <div class="card shadow mx-3 conteudo text-left" style="margin-top: 90px">
      <div class="card-header py-3">
        <h6 class="m-0 font-weight-bold text-primary-dark">
          <i :class="`${title.icon} mr-2`"></i>{{ title.text }}
          <div v-show="carregando" class="spinner-grow">
            <span class="sr-only">Loading...</span>
          </div>
        </h6>
      </div>
      <div class="card-body">
        <div class="row">
          <div class="col-lg-12">
            <fieldset
              v-if="isDataLoaded()"
              :disabled="carregando"
            >
              <Quadro :type="messageType" :message="message" />              
              <form>
                <div class="d-print-none">
                  <router-link
                    :to="`/${this.baseUrl}`"
                    id="btn_voltar"
                    class="btn btn-secondary mr-1"
                  >
                    <i class="fa fa-arrow-left"></i> Voltar</router-link
                  >
                  <button
                    type="button"
                    id="btnSave"
                    class="btn btn-primary mr-1"
                    @click="salvar"
                  >
                    Salvar
                  </button>
                  <button
                    type="button"
                    id="btn_del"
                    class="btn btn-danger mr-1"
                    :disabled="operation === 'insert'"
                    data-toggle="modal"
                    data-target="#modalExcluir"
                  >
                    Excluir
                  </button>
                  <hr />
                </div>
                <fieldset>
                  <div class="form-row">

                    <InputAndLabel
                      column="1"
                      name="id"
                      label="ID"
                      type="text"
                      v-model="dados[idname].value"
                      readonly
                    />

                    <InputAndLabel
                      column="5"
                      name="nome"
                      label="Nome"
                      type="text"
                      maxlength="100"
                      v-model="dados.nome.value"
                      :errorMessage="errors.nome"
                    />

                    <InputAndLabel
                      column="3"
                      name="login"
                      label="Login"
                      type="text"
                      maxlength="100"
                      v-model="dados.login.value"
                      :errorMessage="errors.login"
                    />

                    <SelectAndLabel
                      column="3"
                      name="idperfil"
                      label="Perfil"   
                      :options="combos.idperfil"                   
                      v-model="dados.idperfil.value"
                      :errorMessage="errors.idperfil"
                    />               
                  </div>
                  <div class="form-row">                    

                    <InputAndLabel
                      column="4"
                      name="senha"
                      label="Senha"
                      type="password"
                      maxlength="50"
                      v-model="dados.senha.value"
                      :errorMessage="errors.senha"
                      :enterKey="(e) => clicar('#btnSave')"
                    />
                    <div class="form-group mt-md-4 pt-md-3 ml-md-0 ml-2">
                      <CheckboxAndLabel
                        name="inativo"
                        v-model="dados.inativo.value"
                        label="Inativo"
                        :errorMessage="errors.inativo"
                      />
                    </div>                    
                  </div>
                </fieldset>
              </form>
            </fieldset>
          </div>
        </div>
      </div>
    </div>
    <Modal
      id="modalExcluir"
      title="Confirmar Exclusão"
      confirmClass="btn btn-danger"
      confirmText="Excluir"
      :confirmFunction="deletar"
    >
      Tem certeza que deseja excluir este usuário?
    </Modal>
    <ForbiddenModal />
    <LogoutModal />
    <Sidebar/>
  </div>
</template>

<script>
import api from "../services/api";
import Topbar from "@/components/Topbar";
import Sidebar from '@/components/Sidebar.vue';
import InputAndLabel from "@/components/InputAndLabel";
import SelectAndLabel from "@/components/SelectAndLabel";
import Quadro from "@/components/Quadro";
import LogoutModal from "@/components/LogoutModal.vue";
import Modal from "@/components/Modal";
import ViewMixin from "./ViewMixin";
import $ from "jquery";
import {
    ClientErrorException,
  DEFAULT_ERROR_MESSAGE,
  PermissaoException,
  ServerErrorException,
  TokenInvalidoException,
  ValidationException,
} from "../services/exceptions";
import ForbiddenModal from '../components/ForbiddenModal.vue';
import CheckboxAndLabel from '../components/CheckboxAndLabel.vue';

export default {
  name: "Usuario",
  mixins: [ViewMixin],
  components: {
    Topbar,
    Sidebar,
    LogoutModal,
    Modal,
    InputAndLabel,
    SelectAndLabel,
    Quadro,
    ForbiddenModal,
    CheckboxAndLabel
  },
  props: ["id"],
  data: function () {
    return {
      idname: 'idusuario',
      baseUrl: "usuarios",
      title: {
        icon: "fas fa-users",
        text: "Usuários"
      },
      combos: {
        idperfil: []
      }
    }
  },
  mounted() {
    this.defineOperation(this.id);
    this.getCombo().then(this.getData);
  },
  methods: {
    async getCombo() {
      this.carregando = true;

      try {
        let response = await api.get(`/${this.baseUrl}/combos`);
        let data = response.data;
        this.combos = data;
      } catch (e) {
        if (e instanceof ValidationException) {
          this.handleValidationException(e);
        } else if (e instanceof PermissaoException) {
          this.handlePermissaoException();
        } else if (e instanceof TokenInvalidoException) {
          this.handleTokenInvalidoException();
        } else if (e instanceof ClientErrorException || e instanceof ServerErrorException) {
          this.setMessage(e.message, "danger");
        } else {
          this.setMessage(DEFAULT_ERROR_MESSAGE, "danger");
        }        
      }

      this.carregando = false;
    },
    async getData(id = this.id) {
      this.carregando = true;

      try {
        let response = await api.get(`/${this.baseUrl}/${id}`);
        let data = response.data;
        this.setData(data);
      } catch (e) {
        if (e instanceof ValidationException) {
          this.handleValidationException(e);
        } else if (e instanceof PermissaoException) {
          this.handlePermissaoException();
        } else if (e instanceof TokenInvalidoException) {
          this.handleTokenInvalidoException();
        } else if (e instanceof ClientErrorException || e instanceof ServerErrorException) {
          this.setMessage(e.message, "danger");
        } else {
          this.setMessage(DEFAULT_ERROR_MESSAGE, "danger");
        }        
      }

      this.carregando = false;
    },
    async salvar() {
      this.carregando = true;

      try {
        let response;
        let id = this.dados[this.idname].value;
        let newData;
        let fieldsToDelete = [];
        if (this.operation === 'update') {
          newData = this.getDataToUpdate(fieldsToDelete);
          response = await api.put(
            `/${this.baseUrl}/${id}`,
            newData
          );
        } else {
          newData = this.getDataToInsert(fieldsToDelete)
          response = await api.post(`/${this.baseUrl}`, newData);
        }
        let data = response.data;
        id = data.id;
        this.dados[this.idname] = { value: id, oldValue: id };
        this.operation = 'update';

        this.updateData(newData);

        this.changeURL(`/${this.baseUrl}/${id}`);

        this.setMessage(data.successMessage, "success");        
        this.errors = {};
        this.dados.senha = { value: '', oldValue: '' };
      } catch (e) {
        if (e instanceof ValidationException) {
          this.handleValidationException(e);
        } else if (e instanceof PermissaoException) {
          this.handlePermissaoException();
        } else if (e instanceof TokenInvalidoException) {
          this.handleTokenInvalidoException();
        } else if (e instanceof ClientErrorException || e instanceof ServerErrorException) {
          this.setMessage(e.message, "danger");
        } else {
          this.setMessage(DEFAULT_ERROR_MESSAGE, "danger");
        }
      }

      this.carregando = false;
    },
    async deletar() {
      this.carregando = true;

      $("#modalExcluir").modal("hide");

      try {
        let id = this.dados[this.idname].value;
        await api.delete(`/${this.baseUrl}/${id}`);

        this.$router.push(`/${this.baseUrl}`);
      } catch (e) {
        if (e instanceof ValidationException) {
          this.handleValidationException(e);
        } else if (e instanceof PermissaoException) {
          this.handlePermissaoException();
        } else if (e instanceof TokenInvalidoException) {
          this.handleTokenInvalidoException();
        } else if (e instanceof ClientErrorException || e instanceof ServerErrorException) {
          this.setMessage(e.message, "danger");
        } else {
          this.setMessage(DEFAULT_ERROR_MESSAGE, "danger");
        }
      }

      this.carregando = false;
    },
  },
};
</script>

<style>
/* css */
</style>